module.exports = __webpack_public_path__ + "static/media/sport-fitness.1e577954.svg";